import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const AFFILIATE_LINK = "https://slplc.lynmonkel.com/?mid=381754_2228817";

export default function CasinoSlot() {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  const handleRedirect = () => {
    window.location.href = AFFILIATE_LINK;
  };

  return (
    <>
      <Helmet>
        <title>Casino Slot – PlaySpiro</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* Full screen blurred background */}
      <div style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        background: "rgba(10,5,25,0.85)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
        {/* Age verification circle */}
        <div style={{
          width: "320px",
          height: "320px",
          borderRadius: "50%",
          background: "linear-gradient(135deg,#1a0533,#2d0a5e)",
          border: "3px solid rgba(168,85,247,0.6)",
          boxShadow: "0 0 60px rgba(168,85,247,0.4), 0 0 120px rgba(168,85,247,0.2)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "30px",
          textAlign: "center",
          gap: "16px",
        }}>
          {/* 18+ badge */}
          <div style={{
            width: "56px",
            height: "56px",
            borderRadius: "50%",
            background: "rgba(168,85,247,0.2)",
            border: "2px solid rgba(168,85,247,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            fontWeight: "900",
            color: "#a855f7",
          }}>18+</div>

          <p style={{color:"#fff",fontWeight:"700",fontSize:"15px",lineHeight:"1.4",margin:0}}>
            Are you 18 years or older?
          </p>
          <p style={{color:"rgba(255,255,255,0.5)",fontSize:"11px",margin:0}}>
            This site contains gambling content
          </p>

          {/* Buttons */}
          <div style={{display:"flex",gap:"12px",width:"100%"}}>
            <button
              onClick={handleRedirect}
              style={{
                flex:1,
                background:"linear-gradient(135deg,#a855f7,#7c3aed)",
                color:"#fff",
                border:"none",
                borderRadius:"50px",
                padding:"12px 0",
                fontWeight:"800",
                fontSize:"15px",
                cursor:"pointer",
                boxShadow:"0 0 20px rgba(168,85,247,0.5)",
              }}
            >
              ✅ YES
            </button>
            <button
              onClick={handleRedirect}
              style={{
                flex:1,
                background:"rgba(255,255,255,0.08)",
                color:"rgba(255,255,255,0.6)",
                border:"1px solid rgba(255,255,255,0.2)",
                borderRadius:"50px",
                padding:"12px 0",
                fontWeight:"700",
                fontSize:"15px",
                cursor:"pointer",
              }}
            >
              ❌ NO
            </button>
          </div>

          <p style={{color:"rgba(255,255,255,0.3)",fontSize:"9px",margin:0}}>
            Gamble Responsibly • 18+ Only
          </p>
        </div>
      </div>
    </>
  );
}
